import React from 'react';
import { Outlet } from 'react-router-dom';
import { Col, Container, Row } from 'reactstrap';
import GuestGuard from '../../Utils/RouteGuard/GuestGuard';

export const AuthLayout = () => {
   return (
      <GuestGuard>
         <Container fluid>
            <Row>
               <Col xl={5} className="login_two_image" />
               <Col xl={7} className="p-0">
                  <div className="login-card login-dark login-bg">
                     <Outlet />
                  </div>
               </Col>
            </Row>
         </Container>
      </GuestGuard>
   );
};
